

class SliderPhotoContent{

    constructor(element){
        this.main = element;
        this._btn = this.main.querySelector('.slider_photo_content_btn');
        
        
        this._contents = Array.from(this.main.querySelectorAll('.slider-photo-content__content'));
        this._images = Array.from(this.main.querySelectorAll('.slider-photo-content__img-wrapper'));

        this._pager = this.main.querySelector('.slider-pager');
        if(this._pager != null){
            this._pager.children[1].innerHTML = ("00"+this._contents.length).slice(-2);
        }


        this._currentIndex = 0;
        
        


        this._btn.addEventListener('click', this._onClickBtn.bind(this));        


    }

    _onClickBtn(e){
        e.preventDefault();

        let prevIndex = this._currentIndex;

        this._currentIndex = (prevIndex == this._contents.length - 1) ? 0 : prevIndex + 1;
    
        this._images[prevIndex].classList.remove('slider-photo-content__img-wrapper--show');
        
        this._images[this._currentIndex].classList.add('slider-photo-content__img-wrapper--show');
        
        this._contents[prevIndex].classList.remove('slider-photo-content__content--anim');
        
        setTimeout(() => {
            this._contents[prevIndex].classList.remove('slider-photo-content__content--show');
            this._contents[this._currentIndex].classList.add('slider-photo-content__content--show');
            
            setTimeout(() => {
                this._contents[this._currentIndex].classList.add('slider-photo-content__content--anim');

                if(this._pager != null){
                    this._pager.children[0].innerHTML = ("00"+(this._currentIndex + 1)).slice(-2);
                }

            }, 100);
        }, 250);

    }   

}

export default SliderPhotoContent;